"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const light = {
    balck_1: '15, 15, 26',
    gray_0: '44, 44, 53',
    gray_1: '44, 44, 53',
    gray_2: '72, 72, 87',
    gray_3: '106, 106, 120',
    gray_4: '147, 147, 162',
    gray_5: '198, 198, 209',
    gray_6: '225, 225, 232',
    gray_7: '240, 240, 244',
    gray_8: '255, 255, 255',
    listHighlight: {
        color: '15, 15, 26',
        transparency: '0.06',
    },
    primary_1: '66, 129, 255',
    primary_2: '0, 168, 126',
    primary_3: '254, 163, 49',
    primary_4: '242, 93, 82',
    primary_5: '117, 117, 255',
    white_1: '255, 255, 255',
    yellow_1: '235, 144, 45',
};
const dark = {
    balck_1: '15, 15, 26',
    gray_0: '255, 255, 255',
    gray_1: '240, 240, 244',
    gray_2: '225, 225, 232',
    gray_3: '198, 198, 209',
    gray_4: '147, 147, 162',
    gray_5: '106, 106, 120',
    gray_6: '72, 72, 87',
    gray_7: '30, 30, 36',
    gray_8: '15, 15, 26',
    listHighlight: {
        color: '255, 255, 255',
        transparency: '0.06',
    },
    primary_1: '74, 155, 255',
    primary_2: '47, 168, 134',
    primary_3: '217, 140, 50',
    primary_4: '217, 97, 89',
    primary_5: '161, 143, 255',
    white_1: '255, 255, 255',
    yellow_1: '235, 144, 45',
};
const colors = {
    dark,
    light,
};
exports.default = colors;
//# sourceMappingURL=colors.js.map